import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Modal, Result} from "antd";
import {useTranslation} from "react-i18next";
import selector from "@tools/Selectors";
import * as webSocket from "@tools/webSocket/webSocket";

const ConnectionErrorModal: React.FC = () => {
    const delay = 1000;
    const failedCountBeforeError = 2;
    const [noInternet, setNoInternet] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const {t} = useTranslation()
    const failedCount = useRef(0)

    const checkNetworkConnection = useCallback(async () =>
        new Promise(resolve => {
            let xhr = new XMLHttpRequest();
            xhr.open("HEAD", "https://jsonplaceholder.typicode.com/posts", true)
            xhr.timeout = 2000;
            xhr.onload = () => {
                resolve({hasInternet : true})
            }
            xhr.ontimeout = () => {
                resolve({hasInternet : false})
            }
            xhr.onerror = () => {
                resolve({hasInternet : false})
            }
            xhr.send()
        })
    , [])

    useEffect(() => {

        let socketError = webSocket.on("socket_error", () => {
            if(failedCount.current >= failedCountBeforeError) {
                checkNetworkConnection().then((data: any) => {
                    setNoInternet(!data.hasInternet)
                    setShowModal(true)
                })
            }
            else {
                failedCount.current += 1
            }
        });

        let socketSuccess = webSocket.on("socket_success", () => {
            failedCount.current = 0
            setNoInternet(false)
            setShowModal(false)
        });

        return (() => {
            socketError.off()
            socketSuccess.off()
        })
    }, [])


    return (
        <Modal
            centered={true}
            closable={false}
            title={null}
            open={showModal}
            footer={null}
            maskClosable={false}
            mask={true}
            data-test={selector.connectionError.modal}
        >
            <Result
                status="error"
                title={t("connectionError:title")}
                subTitle={noInternet ? t("connectionError:noNetwork") : t("connectionError:description")}
            />

        </Modal>
    )
};

export default ConnectionErrorModal;
